











































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import TemplateTransfer from "./template-transfer.vue";
import { IfEmpty } from "./common";
@Component({
  components: {
    TemplateTransfer,
  },
})
export default class Name extends Vue {
  @Prop()
  private content: any = {}; // 整个content数据
  @Watch("content", { immediate: true })
  private contentChange() {
    this.refresh();
  }
  @Prop()
  private showResult: any; // 是否在非编辑状态显示结果
  @Prop()
  private ifPlay: any; // 是否语音播放中
  @Watch("ifPlay", { immediate: true })
  private ifPlayChange() {
    if (this.ifPlay) {
      this.cLeftTab = this.leftTabNav[0].title;
    }
  }
  @Prop()
  private playIndex: any; // 当前播放的index
  @Prop()
  private hideReport: any; // 是否隐藏报告
  @Prop()
  private hideName: any; // 是否隐藏名称
  private detail: any = {};
  private redIndex: any = -1; // 需要标红提示未填的index
  private leftTabNav: any[] = [];
  private cLeftTab: any = "";
  private disabledDate: any = this.endDate();
  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  private scrollToTop() {
    const parent = (document as any).getElementById("liangbiao-detail");
    parent.scrollTop = 0;
    if (this.leftTabNav.length > 0) {
      this.cLeftTab = this.leftTabNav[0].title;
    }
  }
  private refresh() {
    this.redIndex = -1;
    this.leftTabNav = [];
    // this.cLeftTab = "";
    this.detail = {};
    if (this.content) {
      this.detail = JSON.parse(JSON.stringify(this.content));
      if (this.detail.template && this.detail.template.is_group) {
        this.getLeftTab();
      }
    }
  }
  private goReport() {
    this.$emit("goReport", this.detail.id);
  }
  private getLeftTab() {
    let leftTabNav: any = [];
    this.detail.data.forEach((items: any, index: any) => {
      if (items.group) {
        // 如果标题结尾是“判定”，则不加入左侧导航
        leftTabNav.push({ ...items, children: [], index: index });
      } else {
        if (leftTabNav.length > 0) {
          leftTabNav[leftTabNav.length - 1].children.push(items);
        }
      }
    });
    this.leftTabNav = leftTabNav;
    if (!this.cLeftTab && leftTabNav.length > 0) {
      this.cLeftTab = leftTabNav[0].title;
    }
  }
  private scrollTo(item: any) {
    if (this.ifPlay) {
      this.$message.warning("请先关闭语音播放");
      return;
    }
    this.cLeftTab = item.title;
    const parent = (document as any).getElementById("liangbiao-detail");
    const child = (document as any).getElementById("liangbiao" + item.index);
    parent.scrollTop = child.offsetTop - parent.offsetTop;
  }
  private scrollEvent() {
    const parent = (document as any).getElementById("liangbiao-detail");
    if (parent) {
      const scrollTop = parent.scrollTop;
      const parentTop = parent.offsetTop + 14;
      this.detail.data.forEach((ele: any, i: any) => {
        if (i < this.leftTabNav.length) {
          const cuEle = document.getElementById("liangbiao" + i);
          const nextEle = document.getElementById("liangbiao" + (i + 1));
          if (cuEle && nextEle) {
            const cuTop = cuEle.offsetTop - parentTop;
            const nextTop = nextEle.offsetTop - parentTop;
            if (scrollTop >= cuTop && scrollTop < nextTop) {
              // 找到对应的leftTabNav
              const findLeftTabNav = this.leftTabNav.find(
                (item: any) => item.index == i
              );
              if (findLeftTabNav) {
                this.cLeftTab = findLeftTabNav.title;
              }
            }
          }
        } else {
          const cuEle = document.getElementById("liangbiao" + i);
          if (cuEle) {
            const cuTop = cuEle.offsetTop - parentTop;
            if (scrollTop >= cuTop) {
              const findLeftTabNav = this.leftTabNav.find(
                (item: any) => item.index == i
              );
              if (findLeftTabNav) {
                this.cLeftTab = findLeftTabNav.title;
              }
            }
          }
        }
      });
    }
  }
  private updateWholeTem(e: any) {
    this.detail.data = e;
    this.$forceUpdate();
    this.updateContent(this.detail);
  }
  private updateContent(e: any) {
    this.$emit("updateContent", e);
  }
  changeCollectTime(e: any) {
    this.detail.collect_time = e;
    this.$emit("updateContent", this.detail);
  }
  // 组件内部触发页面的保存按钮
  private saveContent() {
    this.$emit("saveContent");
  }
  private changeAudio(e: any) {
    this.$emit("changeAudio", e);
  }

  /**
   * 保存前的验证
   */
  private savePre() {
    return new Promise((resolve, reject) => {
      // 判断必填项是否填完
      for (let i = 0; i < this.detail.data.length; i++) {
        const weitian = IfEmpty(this.detail.data[i]);
        if (weitian) {
          // 弹提示哪个未填,并用红框框上
          this.$message.warning(this.detail.data[i].title + "为必填项！");
          this.redIndex = i;
          // 滚动到没填的题目
          const parent = (document as any).getElementById("liangbiao-detail");
          const child = (document as any).getElementById("liangbiao" + i);
          parent.scrollTop = child.offsetTop - parent.offsetTop;
          resolve(false);
          return;
        }
      }
      resolve(true);
    });
  }
}
